import { DateField, TextField } from '@refinedev/antd';
import { useOne } from '@refinedev/core';
import { Card, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import LinkTextField from '@/components/general/LinkTextField';
import { COMPANY_URLS, TECHNICIAN_URLS } from '@/constants/urls';

interface ServiceOrderShowDetailProps {
  serviceOrder: any;
}

const ServiceOrderShowDetail = (props: ServiceOrderShowDetailProps) => {
  const { t } = useTranslation();
  const { serviceOrder } = props;
  const { result: contactData } = useOne({
    resource: COMPANY_URLS.GET_CONTACT.substring(1),
    id: serviceOrder.contact_data?.toString(),
  });

  return (
    <Card className="ServiceOrderShowSection">
      <div className="ServiceOrderShowTitle">{t('Detalles de la orden de servicio')}</div>
      <div className="ServiceOrderShowDataCard">
        <div className="ServiceOrderShowData">
          <b>{t('Técnico')}</b>
          <div>
            <LinkTextField
              admin
              to={`${TECHNICIAN_URLS.ADMIN}/${serviceOrder.technician?.id}`}
              label={serviceOrder.technician?.nombre ?? '-'}
            />
          </div>
        </div>
        <div className="ServiceOrderShowData">
          <b>{t('Empresa')}</b>
          <div>
            <LinkTextField
              admin
              to={`${COMPANY_URLS.ADMIN_EMPRESA}/${serviceOrder.company?.id}`}
              label={serviceOrder.company?.full_name ?? '-'}
            />
          </div>
        </div>
        <div className="ServiceOrderShowData">
          <b>{t('Contacto de la empresa')}</b>
          <div>
            <Typography.Text type="secondary">Nombre: </Typography.Text>
            <TextField value={contactData?.name ?? '-'} />
          </div>
          <div>
            <Typography.Text type="secondary">Email: </Typography.Text>
            <TextField value={contactData?.email ?? '-'} />
          </div>
          <div>
            <Typography.Text type="secondary">Teléfono: </Typography.Text>
            <TextField value={contactData?.phone ?? '-'} />
          </div>
        </div>
        <div className="ServiceOrderShowData">
          <b>{t('Fecha del servicio')}</b>
          <div>
            {serviceOrder.service_date ? (
              <DateField value={serviceOrder.service_date} format="LL" />
            ) : (
              '-'
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default ServiceOrderShowDetail;
